(function () {
  var root = document.querySelector("[data-buy-now]");

  if (!root) {
    return;
  }

  var section = root.closest(".buy-now") || root.closest("section");
  var packEl = root.querySelector("[data-buy-pack]");
  var saveEl = root.querySelector("[data-buy-save]");
  var priceEl = root.querySelector("[data-buy-price]");
  var recommendEl = root.querySelector("[data-buy-recommend]");
  var compareEl = root.querySelector("[data-buy-compare]");
  var subscribePriceEl = root.querySelector("[data-buy-subscribe-price]");
  var onetimePriceEl = root.querySelector("[data-buy-onetime-price]");
  var buyBtn = section ? section.querySelector("[data-buy-btn]") : root.querySelector("[data-buy-btn]");
  var directCheckout = root.dataset.directCheckout === "true";
  var options = root.querySelectorAll("[data-buy-option]");
  var nails = root.querySelectorAll("[data-buy-nail]");
  var deliveries = root.querySelectorAll("[data-buy-delivery]");

  var visualContainer = section ? section.querySelector("[data-buy-visual]") : null;
  var visualImages = visualContainer
    ? visualContainer.querySelectorAll("[data-buy-visual-img]")
    : [];

  var variantId = buyBtn ? buyBtn.dataset.variantId : null;
  var selectedPens = buyBtn ? Number(buyBtn.dataset.pens) || 1 : 1;
  var activeOption = null;
  var activeNail = null;
  var delivery = "subscribe";
  var subscribeDiscount = Number(root.dataset.subscribeDiscount) || 25;
  var sellingPlans = {};
  try {
    sellingPlans = JSON.parse(root.dataset.sellingPlans || "{}") || {};
  } catch (e) {
    sellingPlans = {};
  }
  var sellingPlanId = root.dataset.sellingPlanId || "";
  var switchSaveText = root.dataset.switchSaveText || "Switch to Subscribe & Save to save ";
  var btnPrefix = buyBtn ? buyBtn.dataset.btnText || "Choose" : "Choose";
  var shipsEl = root.querySelector("[data-subscribe-ships]");

  function sellingPlanIdForPens(pens) {
    var months = Number(pens) >= 6 ? 2 : 1;
    var id = sellingPlans[months] || sellingPlans[String(months)];
    return id ? String(id) : sellingPlanId;
  }

  function shipsTextForPens(pens) {
    return Number(pens) >= 6 ? "Ships every 2 months" : "Ships every 1 month";
  }

  function syncSubscribePlan(pens, btn) {
    if (btn && btn.dataset.packMode === "product") {
      sellingPlanId = btn.dataset.sellingPlanId || "";
      if (btn.dataset.subscribeDiscount) {
        subscribeDiscount = Number(btn.dataset.subscribeDiscount) || subscribeDiscount;
      }
      if (shipsEl && btn.dataset.ships) {
        shipsEl.textContent = btn.dataset.ships;
      }
      return;
    }

    if (btn && btn.dataset.sellingPlanId) {
      sellingPlanId = btn.dataset.sellingPlanId;
      if (btn.dataset.subscribeDiscount) {
        subscribeDiscount = Number(btn.dataset.subscribeDiscount) || subscribeDiscount;
      }
      if (shipsEl && btn.dataset.ships) {
        shipsEl.textContent = btn.dataset.ships;
      }
      return;
    }

    sellingPlanId = sellingPlanIdForPens(pens);
    if (shipsEl) {
      shipsEl.textContent = shipsTextForPens(pens);
    }
  }

  function goToPackUrl(url) {
    if (!url || (window.Shopify && window.Shopify.designMode)) {
      return false;
    }

    var target;
    try {
      target = new URL(url, window.location.origin);
    } catch (e) {
      return false;
    }

    var current = new URL(window.location.href);
    var samePath = target.pathname.replace(/\/$/, "") === current.pathname.replace(/\/$/, "");
    if (samePath) return false;

    ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "utm_id", "fbclid", "gclid", "ttclid", "msclkid"].forEach(function (key) {
      var value = current.searchParams.get(key);
      if (value && !target.searchParams.has(key)) {
        target.searchParams.set(key, value);
      }
    });

    window.location.assign(target.toString());
    return true;
  }

  function rememberPackInUrl(btn) {
    if (!btn || !btn.dataset.productUrl) {
      return false;
    }

    return goToPackUrl(btn.dataset.productUrl);
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString("en-GB", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 2,
    });
  }

  function subscribePrice(cents) {
    var discounted = cents * (100 - subscribeDiscount) / 100;
    return Math.ceil(discounted - 1e-6);
  }

  function currentPriceCents() {
    if (!activeOption) {
      return 0;
    }

    var packPrice = Number(activeOption.dataset.packPrice) || 0;
    return delivery === "subscribe" ? subscribePrice(packPrice) : packPrice;
  }

  function updateBuyBtnLabel() {
    if (!buyBtn || !activeOption) {
      return;
    }

    var unitCount = Number(activeOption.dataset.unitCount) || selectedPens;
    var pensWord = unitCount === 1 ? "Pen" : "Pens";
    buyBtn.textContent = btnPrefix + " " + unitCount + " " + pensWord + " — " + formatMoney(currentPriceCents());
  }

  function updateDeliveryPrices() {
    if (!activeOption) {
      return;
    }

    var packPrice = Number(activeOption.dataset.packPrice) || 0;
    var salePrice = subscribePrice(packPrice);

    if (compareEl) {
      compareEl.textContent = formatMoney(packPrice);
    }

    if (subscribePriceEl) {
      subscribePriceEl.textContent = formatMoney(salePrice);
    }

    if (onetimePriceEl) {
      onetimePriceEl.textContent = formatMoney(packPrice);
    }
  }

  function updateSummary() {
    if (!activeOption) {
      return;
    }

    var unitCount = Number(activeOption.dataset.unitCount) || 1;
    var ml = activeOption.dataset.ml;
    var packPrice = Number(activeOption.dataset.packPrice) || 0;
    var salePrice = currentPriceCents();
    var pensWord = unitCount === 1 ? "pen" : "pens";

    if (packEl) {
      packEl.textContent = unitCount + " " + pensWord + " • " + ml + "ml";
    }

    if (priceEl) {
      priceEl.textContent = formatMoney(salePrice);
    }

    if (saveEl) {
      var packSaved = Number(activeOption.dataset.saved) || 0;
      if (delivery === "subscribe") {
        var subscribeSaved = Math.max(0, packPrice - salePrice);
        saveEl.textContent = formatMoney(subscribeSaved + packSaved);
      } else if (packSaved > 0) {
        saveEl.textContent = formatMoney(packSaved);
      } else {
        saveEl.textContent = switchSaveText + subscribeDiscount + "%";
      }
    }
  }

  function selectOption(btn, fromNail, updateUrl) {
    if (!btn) {
      return;
    }

    selectedPens = Number(btn.dataset.pens) || 1;
    activeOption = btn;

    if (btn.dataset.variantId) {
      variantId = btn.dataset.variantId;
      if (buyBtn) buyBtn.dataset.variantId = variantId;
    }

    options.forEach(function (option) {
      var isActive = option === btn;
      option.classList.toggle("buy-now__option--active", isActive);
      option.setAttribute("aria-pressed", isActive ? "true" : "false");
    });

    var optionIndex = btn.dataset.buyOption;
    if (visualImages.length > 0) {
      visualImages.forEach(function (img) {
        if (img.dataset.buyVisualImg === optionIndex) {
          img.classList.remove("buy-now__image--hidden");
        } else {
          img.classList.add("buy-now__image--hidden");
        }
      });
    }

    if (buyBtn) {
      buyBtn.dataset.pens = selectedPens;
      buyBtn.dataset.quantity = btn.dataset.quantity || String(selectedPens);
    }

    syncSubscribePlan(selectedPens, btn);

    if (updateUrl && rememberPackInUrl(btn)) {
      return;
    }

    if (!fromNail && recommendEl && !activeNail) {
      recommendEl.textContent = btn.dataset.description || "";
    }

    updateDeliveryPrices();
    updateSummary();
    updateBuyBtnLabel();
    syncStickyCart(btn);
  }

  function syncStickyCart(btn) {
    var sticky = document.querySelector("[data-sticky-cart]");
    if (!sticky || !btn) {
      return;
    }

    var pens = btn.dataset.pens;
    sticky.querySelectorAll("[data-sticky-option]").forEach(function (opt) {
      opt.classList.toggle("sticky-cart__option--active", opt.dataset.pens === pens);
    });

    var priceEl = sticky.querySelector("[data-sticky-price]");
    var stickyAddBtn = sticky.querySelector("[data-sticky-add-btn]");
    if (priceEl) {
      priceEl.textContent = btn.dataset.priceDisplay || formatMoney(Number(btn.dataset.packPrice));
    }
    if (stickyAddBtn) {
      stickyAddBtn.dataset.pens = pens;
      if (btn.dataset.variantId) stickyAddBtn.dataset.variantId = btn.dataset.variantId;
      if (btn.dataset.quantity) stickyAddBtn.dataset.quantity = btn.dataset.quantity;
    }
  }

  function selectNail(nail, fromUser) {
    if (!nail) {
      return;
    }

    activeNail = nail;

    nails.forEach(function (option) {
      var isActive = option === nail;
      option.classList.toggle("buy-now__nail--active", isActive);
      option.setAttribute("aria-pressed", isActive ? "true" : "false");
    });

    if (recommendEl) {
      recommendEl.textContent = nail.dataset.recommendText || "";
    }

    var recommendedPens = Number(nail.dataset.recommendedPens) || 0;
    var match = null;
    options.forEach(function (option) {
      if (Number(option.dataset.pens) === recommendedPens) {
        match = option;
      }
    });

    selectOption(match || activeOption || options[0], true, !!fromUser);
  }

  function selectDelivery(type) {
    delivery = type === "subscribe" ? "subscribe" : "onetime";

    deliveries.forEach(function (option) {
      var isActive = option.dataset.buyDelivery === delivery;
      option.classList.toggle("buy-now__delivery-option--active", isActive);
      option.setAttribute("aria-pressed", isActive ? "true" : "false");
    });

    updateDeliveryPrices();
    updateSummary();
    updateBuyBtnLabel();
  }

  if (buyBtn) {
    buyBtn.addEventListener("click", async function (event) {
      event.preventDefault();
      var lineVariant = (activeOption && activeOption.dataset.variantId) || variantId;
      if (!lineVariant) return;

      var initialText = buyBtn.textContent;
      var redirected = false;
      buyBtn.disabled = true;
      buyBtn.textContent = directCheckout ? "Redirecting..." : "Adding...";

      try {
        var sectionsPayload = {};
        if (!directCheckout) {
          var drawer = document.querySelector("[data-cart-drawer-root]");
          if (drawer && drawer.dataset.sectionId) {
            var cartPath = (window.__glowRoutes && window.__glowRoutes.cartUrl) || "/cart";
            sectionsPayload = {
              sections: drawer.dataset.sectionId,
              sections_url: cartPath.startsWith("/") ? cartPath : "/" + cartPath,
            };
          }
        }

        var quantity = Number(activeOption && activeOption.dataset.quantity) || 1;
        var payload = Object.assign(
          { id: Number(lineVariant), quantity: quantity },
          sectionsPayload
        );

        if (activeOption && activeOption.dataset.packMode === "product") {
          payload.properties = { _pack_mode: "product" };
        }

        if (delivery === "subscribe" && sellingPlanId) {
          payload.selling_plan = Number(sellingPlanId);
        }

        var res = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
        });

        if (!res.ok && payload.selling_plan) {
          delete payload.selling_plan;
          res = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify(payload),
          });
        }

        if (!res.ok) throw new Error("Add to cart failed");
        var data = await res.json();

        if (directCheckout) {
          redirected = true;
          window.location.href = "/checkout";
          return;
        }

        if (data.sections && window.cartUi && window.cartUi.applyBundledSections) {
          window.cartUi.applyBundledSections(data.sections);
        }

        if (window.cartUi) {
          await window.cartUi.syncCartCountFromApi();
          if (!window.cartUi.isDrawerOpen()) {
            window.cartUi.openDrawer();
          }
        }
      } catch (err) {
        console.error(directCheckout ? "Buy now checkout error:" : "Buy now add to cart error:", err);
      } finally {
        if (!redirected) {
          buyBtn.disabled = false;
          updateBuyBtnLabel();
          if (!activeOption) {
            buyBtn.textContent = initialText;
          }
        }
      }
    });
  }

  options.forEach(function (option) {
    option.addEventListener("click", function () {
      selectOption(option, false, true);
    });
  });

  nails.forEach(function (nail) {
    nail.addEventListener("click", function () {
      selectNail(nail, true);
    });
  });

  deliveries.forEach(function (option) {
    option.addEventListener("click", function () {
      selectDelivery(option.dataset.buyDelivery);
    });
  });

  var queriedPack = null;
  try {
    var packHandle = new URLSearchParams(window.location.search).get("pack");
    if (packHandle) {
      options.forEach(function (option) {
        if (option.dataset.productHandle === packHandle) {
          queriedPack = option;
        }
      });
    }
  } catch (e) {
    queriedPack = null;
  }

  var defaultNail = null;
  nails.forEach(function (nail) {
    if (nail.dataset.default === "true") {
      defaultNail = nail;
    }
  });

  if (queriedPack) {
    selectOption(queriedPack, false, false);
    var queriedPens = Number(queriedPack.dataset.pens) || 0;
    nails.forEach(function (nail) {
      var isActive = Number(nail.dataset.recommendedPens) === queriedPens;
      nail.classList.toggle("buy-now__nail--active", isActive);
      nail.setAttribute("aria-pressed", isActive ? "true" : "false");
      if (isActive) activeNail = nail;
    });
    if (activeNail && recommendEl) {
      recommendEl.textContent = activeNail.dataset.recommendText || "";
    }
  } else if (defaultNail) {
    selectNail(defaultNail);
  } else if (nails.length) {
    selectNail(nails[0]);
  } else if (options.length) {
    selectOption(options[0], false, false);
  }

  selectDelivery("subscribe");

  if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === "function") {
    window.Shopify.PaymentButton.init();
  }
  if (window.Shopify && window.Shopify.StorefrontExpressButtons && typeof window.Shopify.StorefrontExpressButtons.initialize === "function") {
    window.Shopify.StorefrontExpressButtons.initialize();
  }
})();
